import React from 'react';
import { SplitPanelUtil } from '../../commonUtils/SplitPanelUtil';
import HierarchyFileDrop from './HierarchyFileDrop';
import { Checkbox, Accordion } from '@scuf/common';

import './OrganisationPanelReuploadView.scss';
import i18next from '../../../i18next';


interface IOrganisationPanelReuploadViewProps {
  setUploadDocumentId: (documentId: string | undefined) => void;
  selectedNodeId: string;
  cancelExcelUpload: () => void;
  commitExcelUpload: (
    addNewNodes: boolean,
    updateExistingNodes: boolean,
    disableOrphanedNodes: boolean
  ) => void;
  uploadDocumentId: string | undefined;
  isSendingExcelCommit: boolean;
  checkboxStateAddNewNodes: boolean;
  setCheckboxStateAddNewNodes: (val: boolean) => void;
  checkboxStateUpdateExistingNodes: boolean;
  setCheckboxStateUpdateExistingNodes: (val: boolean) => void;
  checkboxStateDisableOrphanNodes: boolean;
  setCheckboxStateDisableOrphanNodes: (val: boolean) => void;
}

export const OrganisationPanelReuploadView = (
  props: IOrganisationPanelReuploadViewProps
) => {
  return (
    <SplitPanelUtil.PanelContentMain>
      <SplitPanelUtil.PanelContentMainSection>
        <div className="organisation-panel-reupload-view">
          <div>
            <Accordion defaultActiveIndex={-1} className="list-item-accordion">
              <Accordion.Content title={<>{i18next.t('importSettings')}</>} arrowPosition="right">
                <Checkbox
                  label={i18next.t('addNodesSites')}
                  checked={props.checkboxStateAddNewNodes}
                  onChange={checked =>
                    props.setCheckboxStateAddNewNodes(checked)
                  }
                />
                <Checkbox
                  label={i18next.t('updateNodesSites')}
                  checked={props.checkboxStateUpdateExistingNodes}
                  onChange={checked =>
                    props.setCheckboxStateUpdateExistingNodes(checked)
                  }
                />

                <Checkbox
                  label={i18next.t('disableNodesSites')}
                  checked={props.checkboxStateDisableOrphanNodes}
                  onChange={checked =>
                    props.setCheckboxStateDisableOrphanNodes(checked)
                  }
                />
              </Accordion.Content>
            </Accordion>
          </div>
          <HierarchyFileDrop
            setUploadDocumentId={props.setUploadDocumentId}
            editOrgId={props.selectedNodeId}
          />
        </div>
      </SplitPanelUtil.PanelContentMainSection>
    </SplitPanelUtil.PanelContentMain>
  );
};

export default OrganisationPanelReuploadView;
